import styled from "styled-components";

export const Container = styled.section`
  margin-top: 10rem;
  padding: 4rem 2rem;
  background-color: var(--black);
  color: var(--pink);

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
    color: #ffffff;
  }

  .award-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    justify-content: center;
    margin-top: 2rem;
  }

  .award-card {
    background-color: #1c1c1e;
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 0 12px rgba(0, 191, 255, 0.25);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .award-card:hover {
    transform: scale(1.03);
  }

  .award-image {
    width: 100%;
    height: 300px;
    object-fit: contain;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background-color: #2a2a2e;
  }

  .award-info {
    padding: 1rem;
  }

  .award-info h3 {
    margin-bottom: 0.5rem;
    font-size: 2rem;
    color: var(--green);
  }

  .award-info p {
    margin: 0.25rem 0;
    font-size: 1.5rem;
    color: var(--blue);
  }

  @media(max-width: 960px) {
    .award-grid {
      grid-template-columns: 1fr;
    }
  }
`;
